import { useState } from 'react';
import { useSelector } from 'react-redux';
import { CardProvider, } from '../type/enums';
import { getAccountsList, getIsV2ApiVersion } from '../selectors';
import { IAccountList, TokenData } from '../type/types';
import jwtDecode from 'jwt-decode';


const checkIfAccountIsMigrated = (token: string): boolean => {
    try {
        const decoded: TokenData = jwtDecode(token);
        const { accountIdV1, accountIdV2 } = decoded;
        return Boolean(accountIdV1 && accountIdV2 );
    } catch (error) {
        console.error('Failed to decode token:', error);
        return false;
    }
};

const useAccountMigrationCheck = (token: string) => {
    const isV2ApiVersion = useSelector(getIsV2ApiVersion);
    const isAccountMigrated = checkIfAccountIsMigrated(token) && isV2ApiVersion
    const [showPreviousAccountTransactions, setShowPreviousAccountTransactions] = useState(false);
    const selectedAccountCardProvider = showPreviousAccountTransactions ? CardProvider.EPS : CardProvider.TRIBE;
    const accountsList = useSelector(getAccountsList) as IAccountList[];
    const selectedAccountBankNumber = accountsList.find((account: IAccountList) => account.provider === selectedAccountCardProvider)?.bankAccountNumber;
   
    const toggleShowPreviousTransactions = () => {
        setShowPreviousAccountTransactions(prevState => !prevState);
    };
  
    return {
        isAccountMigrated,
        selectedAccountCardProvider,
        selectedAccountBankNumber,
        showPreviousAccountTransactions,
        toggleShowPreviousTransactions
    };
};

export default useAccountMigrationCheck;